"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedMarkupWrapperInPage = exports.FormattedMarkupWrapperInTooltip = exports.MarkupTooltipStyleClass = exports.MarkupPageStyleClass = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const StyleFunctions_1 = require("./StyleFunctions");
const markupLineHeight = 1.5;
const markupLetterSpacing = 0.2;
const h1FontSize = 18;
const h2FontSize = 16;
const h3FontSize = 14;
const bodyFontSize = 13;
/**
 * Intended to be used in locations such as "database description" which shows up on the database
 * place page. Using H1 in textile there without these styles causes the rendered HTML to look
 * much more prominent than tableau's internal content, e.g.: the database title.
 *
 * These styles are based on the tableau design library and essentially use everything a step down
 * H1 in textile is rendered as a tableau H2 for example.
 *
 * For more information see: https://tableau.invisionapp.com/share/84WXCW9YSN9#/443420327_Artboard_Copy
 */
const MarkupPageStyles = {
    lineHeight: markupLineHeight,
    letterSpacing: markupLetterSpacing,
    fontSize: bodyFontSize,
    $nest: {
        h1: {
            fontSize: h1FontSize,
        },
        h2: {
            fontSize: h2FontSize,
        },
        h3: {
            fontSize: h3FontSize,
        },
    },
};
exports.MarkupPageStyleClass = (0, StyleFunctions_1.cssClass)('markup-page-style', MarkupPageStyles);
const MarkupPageStyle = (0, vizportalclient_common_components_1.divWithStyle)('markupPageWrapper', MarkupPageStyles);
const modalMultiplier = 0.07;
/**
 * Intended to be used in locations such as "data quality warning" or "certification" which show up
 * as a popup pane and are generally in a constrained area.
 *
 * These styles are based on the tableau design library and essentially use everything a step down
 * H1 in textile is rendered as a tableau H2 for example.
 *
 * For more information see: https://tableau.invisionapp.com/share/84WXCW9YSN9#/443420327_Artboard_Copy
 */
const MarkupTooltipStyles = {
    lineHeight: markupLineHeight,
    letterSpacing: markupLetterSpacing,
    fontSize: bodyFontSize - (bodyFontSize * modalMultiplier),
    $nest: {
        h1: {
            fontSize: h1FontSize - (h1FontSize * modalMultiplier),
        },
        h2: {
            fontSize: h2FontSize - (h2FontSize * modalMultiplier),
        },
        h3: {
            fontSize: h3FontSize - (h3FontSize * modalMultiplier),
        },
    },
};
exports.MarkupTooltipStyleClass = (0, StyleFunctions_1.cssClass)('markup-tooltip-style', MarkupTooltipStyles);
const MarkupTooltipStyle = (0, vizportalclient_common_components_1.divWithStyle)('markupPaneWrapper', MarkupTooltipStyles);
function FormattedMarkupWrapperInTooltip(props) {
    const { linksDisabled } = props, restProps = tslib_1.__rest(props, ["linksDisabled"]);
    const allowedTags = linksDisabled ? widgets_1.DefaultAllowedTags.filter(t => t !== 'a') : undefined;
    return (react_1.default.createElement(MarkupTooltipStyle, null,
        react_1.default.createElement(widgets_1.TextFormatterDisplayWidget, Object.assign({}, restProps, { allowedTags: allowedTags }))));
}
exports.FormattedMarkupWrapperInTooltip = FormattedMarkupWrapperInTooltip;
function FormattedMarkupWrapperInPage(props) {
    const { linksDisabled } = props, restProps = tslib_1.__rest(props, ["linksDisabled"]);
    const allowedTags = linksDisabled ? widgets_1.DefaultAllowedTags.filter(t => t !== 'a') : undefined;
    return (react_1.default.createElement(MarkupPageStyle, null,
        react_1.default.createElement(widgets_1.TextFormatterDisplayWidget, Object.assign({}, restProps, { allowedTags: allowedTags }))));
}
exports.FormattedMarkupWrapperInPage = FormattedMarkupWrapperInPage;
//# sourceMappingURL=MarkupStyles.js.map